var chunkToChildrenMap = {
	"634": [
		8546
	],
	"1318": [
		8546
	],
	"4985": [
		9139,
		2591,
		9934
	],
	"8546": [
		8546,
		1490
	],
	"9178": [
		9139,
		2591,
		9934,
		1318,
		1887,
		9382,
		8546,
		8945
	],
	"9382": [
		8546
	],
	"9934": [
		6319,
		7206,
		1285,
		8546,
		8945
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));